import { createWebHistory, createRouter } from "vue-router";
const Waffle = () => import('../components/Waffle.vue');
// const ComponentTests = () => import("../components/UI/tests/KitchenComponent.vue");


const routes = [
  // {
  //   path: "/tests/components",
  //   name: "ComponentTests",
  //   component: ComponentTests,
  // },
    {
      path:'/reviews-report',
      name:'reviews-report',
      component:()=>import('../components/reviewsReport.vue')
    },
  {
    path: "/:pathMatch(.*)*",
    name: "Waffle",
    component: Waffle,
  }
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(){
    return false
  }
});
let historyIndex = Number(sessionStorage.getItem('history-index') || 0)

router.beforeEach((to, from, next) => {
  const toIndex = sessionStorage.getItem(to.fullPath+'_index') ? Number(sessionStorage.getItem(to.fullPath+'_index')):null
  if (toIndex) {
    historyIndex = toIndex
    sessionStorage.setItem('history-index', historyIndex)
  } else {
    historyIndex += 1
    sessionStorage.setItem('history-index', historyIndex)
    sessionStorage.setItem(to.fullPath+'_index', historyIndex)
  }

  next()
})

export default router;